import React from "react";
// import villageCampaignImg from "../../../Assets/Images/about/villageCampaignImg.png";
import about_approach_1 from "../../../Assets/Images/about/about_approach_1.png";
import AboutHeadings from "./AboutHeadings";

const sections = [
  {
    title: "Collaborate",
    text: `We are seeking collaboration with other organizations for knowledge sharing, convergence, and leveraging resources for different social causes across the country. Nowadays, the globe is driven by technology and social media. We hope to use the sway of networks to reach more supporters and build a community of support for the deprived community in Odisha, a tribal-dominated state of India. We welcome your thoughts on our social media pages and Facebook. We can speak on Skype calls and communicate via email. By sharing messages and ideas, we aim to create a larger impact within the community with your help.`,
  },
  {
    title: "Campaign",
    text: `AAFSA starts three campaigns in association with its network organizations across Odisha. The "Save Seeds" campaign focuses on protecting and propagating endangered seeds. "Know tongue No trouble" aims to preserve tribal verbal languages that are at risk of extinction. The "Cattle Care" campaign empowers communities to care for their cattle populations. Organizations or individuals interested in these issues are most welcome to collaborate with us.`,
  },
];

const AboutCollaborateCampaign = () => {
  return (
    <div className="sm:py-8 px-4 md:px-[5rem] pb-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {/* Image */}
        <div
          className="hidden lg:flex col-span-1 lg:mt-20 xl:mt-0 text-right"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <img
            src={about_approach_1}
            alt="Collaborate Campaign"
            className="rounded-lg w-full  max-h-[35rem] shadow-lg transform transition-transform duration-500 hover:scale-105"
          />
        </div>

        {/* Content */}
        <div className="col-span-1 mt-8 lg:mt-0 space-y-6">
          {sections.map((section, idx) => (
            <div
              key={idx}
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay={idx * 200} // staggered animation
            >
              <AboutHeadings
                title={section.title}
                textAlign="left"
                titleClassName={"text-[#A93EA8]"}
              />
              <p className="text-sm md:text-base leading-relaxed text-[#555] text-justify tracking-wide sm:px-1">
                {section.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutCollaborateCampaign;
